/**
 * @generated SignedSource<<0dc04304e5bb54b34b088668f880720e>>
 * @relayHash 8de5b7e3e82e3a24e1c6436f4be6aa2a
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8de5b7e3e82e3a24e1c6436f4be6aa2a

import { ConcreteRequest } from 'relay-runtime';
export type validatePhoneNumberQuery$variables = {
  phoneNumber: string;
};
export type validatePhoneNumberQuery$data = {
  readonly validatePhoneNumber: boolean;
};
export type validatePhoneNumberQuery = {
  response: validatePhoneNumberQuery$data;
  variables: validatePhoneNumberQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "phoneNumber"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "phoneNumber",
        "variableName": "phoneNumber"
      }
    ],
    "kind": "ScalarField",
    "name": "validatePhoneNumber",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "validatePhoneNumberQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "validatePhoneNumberQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "8de5b7e3e82e3a24e1c6436f4be6aa2a",
    "metadata": {},
    "name": "validatePhoneNumberQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b3e1e24899b393aa1fce1d3a7c57592b";

export default node;
